import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
function useCountdown(hours: number) {
  const [endTime] = useState(() => {
    const saved = localStorage.getItem('serigrafia-countdown-end');
    if (saved) {
      const parsed = parseInt(saved);
      if (parsed > Date.now()) return parsed;
    }
    const end = Date.now() + hours * 60 * 60 * 1000;
    localStorage.setItem('serigrafia-countdown-end', end.toString());
    return end;
  });
  const [timeLeft, setTimeLeft] = useState(() => Math.max(0, endTime - Date.now()));
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(0, endTime - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  const hours2 = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(timeLeft % (1000 * 60) / 1000);
  return {
    hours: hours2,
    minutes,
    seconds
  };
}
export function CountdownBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(2);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="w-full bg-gradient-to-r from-[#FF1493] to-[#00D4FF] text-white py-2 px-4 relative z-50" data-id="element-50">
      <div className="container mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-semibold" data-id="element-51">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-52" />
        <span data-id="element-53">🔥 OFERTA ESPECIAL — Termina en</span>
        <div className="flex items-center gap-1 font-mono" data-id="element-54">
          <span className="bg-dark/30 px-2 py-0.5 rounded text-white font-bold" data-id="element-55">
            {pad(hours)}
          </span>
          <span data-id="element-56">:</span>
          <span className="bg-dark/30 px-2 py-0.5 rounded text-white font-bold" data-id="element-57">
            {pad(minutes)}
          </span>
          <span data-id="element-58">:</span>
          <span className="bg-dark/30 px-2 py-0.5 rounded text-white font-bold" data-id="element-59">
            {pad(seconds)}
          </span>
        </div>
      </div>
    </div>;
}